import React, { Fragment, useEffect, useState, useMemo, useCallback, useRef } from "react";
import { Accordion, AccordionBody, AccordionHeader, AccordionItem, Table, Button, Card, CardBody, Col, Container, CardHeader, Nav, NavItem, NavLink, Row, Modal, ModalHeader, Form, ModalBody, Label, Input, FormFeedback, Spinner, UncontrolledButtonDropdown, UncontrolledDropdown, DropdownItem, DropdownMenu, DropdownToggle, ButtonGroup } from "reactstrap";
import moment from "moment";
import "moment-timezone";
import { Link } from "react-router-dom";
import classnames from "classnames";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import DeleteModal from "../../../Components/Common/DeleteModal";
import ApproveModal from "../../../Components/Common/ApproveModal";
import { isEmpty } from "lodash";
import { useTable, useGlobalFilter, useAsyncDebounce, useSortBy, useFilters, useExpanded, usePagination, useRowSelect } from "react-table";

import Flatpickr from "react-flatpickr";
import Select from "react-select";

// Formik
import * as Yup from "yup";
import { useFormik } from "formik";

//redux
import { useSelector, useDispatch } from "react-redux";

//Import actions
import { getBank } from "../../../store/bank/action";
import { resetUserState, getUser } from "../../../store/users/action";
import { resetVendorState, getVendor as onGetVendors, addNewVendor as onAddNewVendor, updateVendor as onUpdateVendor, deleteVendor as onDeleteVendor, getVendorLoading } from "../../../store/vendor/action";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import logo from "../../../assets/images/users/user-dummy-img.jpg";

import PropTypes from "prop-types";
import withRouter from "../../../Components/Common/withRouter";
import { withTranslation } from "react-i18next";

import ExportCSVModal from "../../../Components/Common/ExportCSVModal";

import { resetCompanyState, getCompany } from "../../../store/company/action";
import { resetClientState, getClient } from "../../../store/client/action";
import { api } from "../../../config";
import ModalInputFile from "../../../Components/ModalInputFile";
import ExportDoc from "../../../Components/Common/ExportDoc";

const Vendor = (props) => {
  const [placeDefaultVal, setPlaceDefaultVal] = useState("");
  const [modal, setModal] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const [activeTypeTab, setActiveTypeTab] = useState("all");
  const [clientList, setClientList] = useState([]);
  const [companyList, setCompanyList] = useState([]);
  const [mediaType, setMediaType] = useState("");
  const [modalMedia, setModalMedia] = useState(false);
  const [otherDocImg, setOtherDocImg] = useState([]);

  const [positionMessage, setPositionMessage] = useState("");
  const dispatch = useDispatch();

  const { clientSelected, companySelected, branchSelected, userData, userType, userRole, vendors, isVendorCreated, isVendorSuccess, loading, error, villages, villageLoading, companies, companyLoading, clients, clientLoading, banks, bankLoading, users, usersLoading } = useSelector((state) => ({
    clientSelected: state.App.clientSelected,
    companySelected: state.App.companySelected,
    branchSelected: state.App.branchSelected,
    userData: state.App.userData,
    userRole: state.App.userRole,
    userType: state.App.userType,
    vendors: state.Vendor.vendors,
    isVendorCreated: state.Vendor.isVendorCreated,
    isVendorSuccess: state.Vendor.isVendorSuccess,
    loading: state.Vendor.loading,
    companies: state.Company.companies,
    companyLoading: state.Company.loading,
    clientLoading: state.Client.loading,
    clients: state.Client.clients,
    banks: state.Bank.banks,
    bankLoading: state.Bank.loading,
    villages: state.Village.villages,
    villageLoading: state.Village.loading,
    error: state.Vendor.error,
    users: state.Users.users,
    usersLoading: state.Users.loading,
  }));

  const [vendorList, setVendorList] = useState([]);
  const [userList, setUserList] = useState([]);
  const [vendor, setVendor] = useState([]);
  const [info, setInfo] = useState([]);
  const [isExportCSV, setIsExportCSV] = useState(false);
  const [statusActive, setStatusActive] = useState([]);
  const [villageList, setVillageList] = useState([]);
  const [vendorContactItem, setVendorContactItem] = useState([]);
  const [filterDate, setFilterDate] = useState();
  const [bankList, setBankList] = useState([]);

  const [isSearch, setIsSearch] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [approveModal, setApproveModal] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);

  const [printDoc, setPrintDoc] = useState([]);

  const [open, setOpen] = useState("1");
  const toggleAccordion = (id) => {
    if (open === id) {
      setOpen(open);
    } else {
      setOpen(id);
    }
  };

  const statusActiveData = [
    {
      options: [
        { label: "DRAFT", value: "1" },
        { label: "ACTIVE", value: "2" },
        { label: "INACTIVE", value: "3" },
      ],
    },
  ];

  const onClickDelete = (vendor) => {
    setVendor(vendor);
    setDeleteModal(true);
  };

  const onClickApprove = (vendor) => {
    setVendor(vendor);
    setApproveModal(true);
  };

  const handleDeleteVendor = () => {
    if (vendor) {
      dispatch(onDeleteVendor(vendor));
      setDeleteModal(false);
    }
  };

  const handleApproveVendor = () => {
    if (vendor) {
      vendor.setApprove = true;
      dispatch(onUpdateVendor(vendor));
      setApproveModal(false);
    }
  };

  const handleUser = (e, t) => {
    validation.setFieldValue("user", "");
    const param = t === "client" ? { clientId: e, userType: "user" } : { companyId: e, userType: "user" };
    dispatch(getUser(param));
  };

  // useEffect(() => {
  //   setVendorList(vendors);
  // }, [vendors]);

  useEffect(() => {
    setPositionMessage(`${userData?.user?.user_department && userData?.user?.user_department?.name}, ${userData?.user?.user_position && userData?.user?.user_position?.name}`);
    handleUser(userData?.companyId);
    dispatch(resetVendorState());
    dispatch(onGetVendors());
  }, []);

  useEffect(() => {
    if (!isEmpty(vendors)) {
      let filteredVendors = vendors;
      if (activeTypeTab !== "all") {
        filteredVendors = vendors.filter((vendor) => vendor.vendor_status.name === activeTypeTab);
      }
      setVendorList(filteredVendors.map((el) => ({ ...el, isChecked: false })));
      setInfo(vendors[vendors.length - 1]);
      setIsEdit(false);
    }
  }, [vendors]);

  useEffect(() => {
    let dataDoc = [
      {
        id: "name",
        label: "Name",
        isSelected: true,
        data: [],
      },
      {
        id: "phone",
        label: "Phone",
        isSelected: true,
        data: [],
      },
      {
        id: "email",
        label: "Email",
        isSelected: true,
        data: [],
      },
    ];

    if (vendorList.length > 0) {
      vendorList.forEach((data) => {
        if (data.isChecked) {
          Object.entries(data).forEach(([key, value]) => {
            const doc = dataDoc.find((d) => d.id === key);

            if (doc) {
              doc.data.push(value ?? "-");
            }
          });
        }
      });
    }

    setPrintDoc(dataDoc);
  }, [vendorList]);

  useEffect(() => {
    if (!isEmpty(users)) {
      var data = [];
      var opt = [];
      users.forEach((item, key) => {
        const name = item.name;
        const phone = item.phone;
        const email = item.email;
        const id = item.id;
        var obj = { label: name, value: id, phone: phone, email: email };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setUserList(data);
    }
  }, [users]);

  useEffect(() => {
    if (!isEmpty(clients)) {
      var data = [];
      var opt = [];
      clients.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setClientList(data);
    }
  }, [clients]);

  useEffect(() => {
    var data = [];
    var opt = [];
    (companies || []).forEach((item, key) => {
      const name = item.name;
      const id = item.id;
      var obj = { label: name, value: id };
      opt.push(obj);
    });
    var option = { options: opt };
    data.push(option);

    if (companies.length > 0) {
      setCompanyList(data);
    }
  }, [companies]);

  const toggleMedia = useCallback(() => {
    if (modalMedia) {
      setModalMedia(false);
    } else {
      setModalMedia(true);
    }
  }, [modalMedia]);

  const handleSelectFile = (file) => {
    switch (mediaType) {
      case "image":
        validation.setFieldValue("image", file.filename);
        break;
      default:
        setOtherDocImg((val) => [...val, { filename: file.filename, originalname: file.originalname }]);
        break;
    }

    toggleMedia();
  };

  useEffect(() => {
    if (!isEmpty(villages)) {
      var villageData = [];
      var opt = [];
      villages.forEach((item, key) => {
        const village_name = item.village_name;
        const id = item.id;
        const city_name = item.vc.city_name;
        const district_name = item.vd.district_name;
        const province_name = item.vp.province_name;
        var obj = {
          label: village_name + ", " + district_name + ", " + city_name + " - " + province_name,
          value: id,
        };
        opt.push(obj);
      });
      var option = { options: opt };
      villageData.push(option);
      setVillageList(villageData);
    }
  }, [villages]);

  const handleValidDate = (date) => {
    return moment(date, "YYYY/MM/DD").format("MMM D, YYYY");
  };

  const toggleTab = (tab, type) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      setActiveTypeTab(type);
      let filteredVendors = vendors;
      if (type !== "all") {
        filteredVendors = vendors.filter((vendor) => vendor.vendor_status.name === type);
      }
      setVendorList(filteredVendors);
    }
  };

  useEffect(() => {
    if (banks && !banks.length) {
      dispatch(getBank());
    }
  }, [dispatch, banks]);

  useEffect(() => {
    if (!isEmpty(banks)) {
      var data = [];
      var opt = [];
      banks.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setBankList(data);
    }
  }, [banks]);

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      setVendor(null);
      setVendorContactItem([]);
      setPlaceDefaultVal("");
    } else {
      setModal(true);
    }
  }, [modal]);

  const handleGetCompany = useCallback(
    (id) => {
      dispatch(resetCompanyState());
      dispatch(getCompany({ clientId: id }));
    },
    [dispatch]
  );

  const handleVendorClick = useCallback(
    (arg) => {
      const vendor = arg;
      let venaddress = [];
      let venbank = [];
      let venvendor = [];
      vendor.vendor_address.forEach((address) => {
        if (address.isPrimary) venaddress = address;
      });
      const addressName = venaddress ? venaddress.address_name : "";
      const addressLabel = venaddress ? venaddress.description : "";
      const addressValue = venaddress ? venaddress.villageId : "";

      let address_vendor = {};
      for (const address of vendor.vendor_address) {
        if (address.isPrimary) {
          address_vendor = address;
        }
      }

      vendor.vendor_bank &&
        vendor.vendor_bank.forEach((bank) => {
          if (bank.isPrimary) venbank = bank;
        });

      if (vendor.vendor_contact) {
        vendor.vendor_contact.forEach((element) => {
          venvendor.push({
            id: element.id,
            name: element.name,
            email: element.email,
            phone: element.phone,
            position: element.position,
          });
        });
        setVendorContactItem(venvendor);
      }

      setPlaceDefaultVal({
        label: `${address_vendor.village} ${address_vendor.district} ${address_vendor.city} ${address_vendor.province} ${address_vendor.country}`,
        value: `${address_vendor.village} ${address_vendor.district} ${address_vendor.city} ${address_vendor.province} ${address_vendor.country}`,
      });

      setVendor({
        id: vendor.id,
        idBank: venbank.id ?? 0,
        address: {
          label: `${address_vendor.village} ${address_vendor.district} ${address_vendor.city} ${address_vendor.province} ${address_vendor.country}`,
          value: `${address_vendor.village} ${address_vendor.district} ${address_vendor.city} ${address_vendor.province} ${address_vendor.country}`,
        },
        street: address_vendor.description ?? "",
        zip: address_vendor.code ?? "",
        village: address_vendor.village ?? "",
        district: address_vendor.district ?? "",
        city: address_vendor.city ?? "",
        province: address_vendor.province ?? "",
        country: address_vendor.country ?? "",
        name: vendor.name,
        email: vendor.email,
        password: vendor.vendor_user ? vendor.vendor_user.pass : "",
        phone: vendor.phone,
        fax: vendor.fax,
        image: vendor.image,
        tax_number: vendor.tax_number,
        website: vendor.website,
        user:
          vendor.vendor_user === null
            ? ""
            : {
              label: vendor.vendor_user ? vendor.vendor_user.name : "",
              value: vendor.vendor_user ? vendor.vendor_user.id : "",
            },
        description: vendor.description,
        number: venbank.number,
        bank_name: venbank.name,
        bank: venbank.bank_data_bank && {
          label: venbank.bank_data_bank.name,
          value: venbank.id,
        },
        vendor_status: {
          label: vendor.vendor_status.name,
          value: vendor.vendor_status.id,
        },
        vendor_contact: venvendor,
        client: vendor.vendor_client && {
          label: vendor.vendor_client ? vendor.vendor_client.name : "",
          value: vendor.vendor_client ? vendor.vendor_client.id : "",
        },
        company: vendor.vendor_company && {
          label: vendor.vendor_company ? vendor.vendor_company.name : "",
          value: vendor.vendor_company ? vendor.vendor_company.id : "",
        },
        instagram: vendor.social_media && vendor.social_media.instagram,
        facebook: vendor.social_media && vendor.social_media.facebook,
        tiktok: vendor.social_media && vendor.social_media.tiktok,
        youtube: vendor.social_media && vendor.social_media.youtube,
        twitter: vendor.social_media && vendor.social_media.twitter,
      });

      handleGetCompany(vendor.vendor_client.id);
      setIsEdit(true);
      toggle();
    },
    [toggle, userType, handleGetCompany]
  );

  const [isCheckAll, setIsCheckAll] = useState(false);
  const rowsRef = useRef([]);
  const checkedAll = () => {
    const allChecked = rowsRef.current.every((item) => item?.isChecked);
    const visibleIds = rowsRef.current.map((r) => String(r.id));

    const updated = vendorList.map((item) => {
      const isVisible = visibleIds.includes(String(item.id));
      return isVisible ? { ...item, isChecked: !allChecked } : item;
    });
    setVendorList(updated);
    setIsCheckAll(allChecked);
  };

  const columns = useMemo(
    () => [
      {
        id: "#",
        Header: <input type="checkbox" id="checkBoxAll" className="form-check-input" checked={isCheckAll} onChange={checkedAll} />,
        Cell: (cellProps) => {
          let data = cellProps.row.original;
          return (
            <div className="hstack gap-2 mt-4 mt-sm-0">
              <input
                type="checkbox"
                className="dataCheckbox me-2 form-check-input"
                checked={data.isChecked}
                onChange={() => {
                  const updatedData = vendorList.map((d) => (d.id === data.id ? { ...d, isChecked: !d.isChecked } : d));
                  setVendorList(updatedData);
                }}
              />
              <ButtonGroup className="me-1">
                <UncontrolledButtonDropdown>
                  <Button
                    color="light"
                    className="btn-sm"
                    onClick={() => {
                      setInfo(data);
                    }}
                  >
                    <i className="ri-eye-line fs-15"></i>
                  </Button>
                  <Button
                    color="light"
                    className={userType === "admin" || userType === "client" || userType === "company" ? "btn-sm" : userRole && userRole.split(",").indexOf("updateVendor") !== -1 ? "btn-sm" : "btn-sm d-none"}
                    onClick={() => {
                      handleVendorClick(data);
                    }}
                  >
                    <i className="ri-edit-2-line fs-15"></i>
                  </Button>
                  <Button
                    color="light"
                    className={userType === "admin" || userType === "client" || userType === "company" ? "btn-sm" : userRole && userRole.split(",").indexOf("deleteVendor") !== -1 ? "btn-sm" : "btn-sm d-none"}
                    onClick={() => {
                      data.statusId = 3;
                      onClickDelete(data);
                    }}
                  >
                    <i className="ri-delete-bin-line fs-15 text-danger"></i>
                  </Button>
                </UncontrolledButtonDropdown>
              </ButtonGroup>
              {data.statusId === 1 && (
                <button
                  className={userType === "admin" || userType === "client" || userType === "company" ? "btn btn-sm btn-soft-success" : userRole && userRole.split(",").indexOf("approveVendor") !== -1 ? "btn btn-sm btn-soft-success" : "btn btn-sm btn-soft-success d-none"}
                  onClick={() => {
                    data.statusId = 2;
                    onClickApprove(data);
                  }}
                >
                  <i className="ri-checkbox-circle-line label-icon align-middle fs-16 me-1"></i> Approve
                </button>
              )}
            </div>
          );
        },
      },
      {
        id: "#Name",
        Header: "Nama",
        filterable: true,
        accessor: "name",
        Cell: (vendor) => (
          <>
            <div className="d-flex align-items-center">
              <div className="flex-shrink-0">
                {vendor.row.original.image ? (
                  <img src={vendor.row.original.image === "" ? logo : `${api.MEDIA_URL}/media/${vendor.row.original.image}`} alt="" className="avatar-xs rounded-circle me-1" />
                ) : (
                  <div className="flex-shrink-0 avatar-xs me-1">
                    <div className="avatar-title bg-soft-success text-success rounded-circle fs-13">{vendor.row.original.name.charAt(0)}</div>
                  </div>
                )}
              </div>
              <div className="flex-grow-1 ms-2 name">{vendor.row.original.name}</div>
            </div>
          </>
        ),
      },
      {
        id: "#Phone",
        Header: "Telepon",
        accessor: "phone",
        filterable: true,
      },
      {
        id: "#Email",
        Header: "Email",
        accessor: "email",
        filterable: true,
      },
      {
        id: "#Status",
        Header: "Status",
        accessor: "vendor_status.name",
        filterable: true,
        Cell: (cell) => {
          switch (cell.value) {
            case "DRAFT":
              return <span className="badge text-uppercase badge-soft-warning">{cell.value}</span>;
            case "ACTIVE":
              return <span className="badge text-uppercase badge-soft-info">{cell.value}</span>;
            case "INACTIVE":
              return <span className="badge text-uppercase badge-soft-danger">{cell.value}</span>;
            default:
              return <span className="badge text-uppercase badge-soft-warning">{cell.value}</span>;
          }
        },
      },
    ],
    [vendorList, handleVendorClick, logo, userRole, userType, isCheckAll]
  );

  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const onChange = useAsyncDebounce((value) => {
    const resetChecked = vendorList.map((item) => ({
      ...item,
      isChecked: false,
    }));
    setVendorList(resetChecked);
    setIsCheckAll(false);
    setGlobalFilter(value || undefined);
    setGlobalFilterValue(value ?? "");
  }, 300);

  const memoizedData = useMemo(() => vendorList, [vendorList]);

  const {
    getTableProps,
    rows,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    preGlobalFilteredRows,
    setGlobalFilter,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns: columns,
      data: memoizedData,
      defaultColumn: { Filter: null },
      initialState: {
        pageIndex: 0,
        pageSize: 10,
        selectedRowIds: 0,
        globalFilter: globalFilterValue,
      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect
  );

  useEffect(() => {
    const currentRows = rows.map((r) => r.original);
    rowsRef.current = currentRows;
    const allChecked = currentRows.length > 0 && currentRows.every((item) => item.isChecked);
    setIsCheckAll(allChecked);
  }, [rows]);

  const generateSortingIndicator = (column) => {
    return column.isSorted ? (column.isSortedDesc ? " " : "") : "";
  };

  const generateFilterable = (column) => {
    return column.filterable ? (column.isSorted ? (column.isSortedDesc ? " sorting_desc" : " sorting_asc") : " sort") : "";
  };

  const onChangeInSelect = (event) => {
    setPageSize(Number(event.target.value));
  };

  const onChangeInInput = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    gotoPage(page);
  };

  const count = preGlobalFilteredRows.length;
  const [searchValue, setSearchValue] = useState("");

  function handleFilter() {
    let startat = "";
    let endat = "";
    let datearr = filterDate?.split(" to ");
    if (datearr) {
      startat = datearr[0];
      endat = datearr[1] ? datearr[1] : datearr[0];
    }

    var status = statusActive.value ? statusActive.value : "";
    const param = {
      title: searchValue,
      startat: startat,
      endat: endat,
      status: status,
    };
    dispatch(onGetVendors(param));
  }

  const handleResetFilter = () => {
    setFilterDate(null);
    setVendorList([]);
    setSearchValue("");
    setStatusActive([]);
    setGlobalFilter(undefined);
    setGlobalFilterValue("");
    dispatch(resetVendorState());
    dispatch(onGetVendors());
  };

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      company: (vendor && vendor.company) || companySelected,
      client: (vendor && vendor.client) || clientSelected,
      name: (vendor && vendor.name) ?? "",
      user: (vendor && vendor.user) ?? "",
      email: (vendor && vendor.email) ?? "",
      password: (vendor && vendor.password) ?? "",
      phone: (vendor && vendor.phone) ?? "",
      birthat: (vendor && vendor.birthat) ?? "",
      fax: (vendor && vendor.fax) ?? "",
      tax_number: (vendor && vendor.tax_number) ?? "",
      number: (vendor && vendor.number) ?? "",
      website: (vendor && vendor.website) ?? "",
      description: (vendor && vendor.description) ?? "",
      address: (vendor && vendor.address) ?? "",
      vendor_status: vendor && vendor.vendor_status,
      village: vendor && vendor.village,
      bank: (vendor && vendor.bank) ?? "",
      bank_name: (vendor && vendor.bank_name) ?? "",
      idBank: (vendor && vendor.idBank) || 0,
      zip: (vendor && vendor.zip) ?? "",
      street: (vendor && vendor.street) ?? "",
      image: (vendor && vendor.image) ?? "",
      instagram: (vendor && vendor.instagram) ?? "",
      facebook: (vendor && vendor.facebook) ?? "",
      tiktok: (vendor && vendor.tiktok) ?? "",
      youtube: (vendor && vendor.youtube) ?? "",
      twitter: (vendor && vendor.twitter) ?? "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Silahkan isi Nama Supplier").nullable(true),
      phone: Yup.string().required("Silahkan isi No Telp Supplier").nullable(true),
      client: Yup.object().required("Silahkan isi grup perusahaan").nullable(true),
      company: Yup.object().required("Please Select Company").nullable(true),
    }),
    onSubmit: (values) => {
      dispatch(getVendorLoading());
      if (isEdit) {
        let editDataSubmit = {
          id: vendor.id,
          clientId: values.client.value,
          companyId: values.company.value,
          name: values.name,
          email: values.email,
          password: values.password,
          phone: values.phone,
          fax: values.fax,
          tax_number: values.tax_number,
          website: values.website,
          idBank: values.idBank,
          userId: values.user.value,
          bankId: values.bank.value,
          number: values.number,
          bank_name: values.bank_name,
          description: values.description,
          zip: values.zip,
          village: typeof values.address.value === "object" && values.address.value.terms ? values.address.value.terms[0].value : vendor.village,
          district: typeof values.address.value === "object" && values.address.value.terms ? values.address.value.terms[values.address.value.terms.length - 4].value : vendor.district,
          city: typeof values.address.value === "object" && values.address.value.terms ? values.address.value.terms[values.address.value.terms.length - 3].value : vendor.city,
          province: typeof values.address.value === "object" && values.address.value.terms ? values.address.value.terms[values.address.value.terms.length - 2].value : vendor.province,
          country: typeof values.address.value === "object" && values.address.value.terms ? values.address.value.terms[values.address.value.terms.length - 1].value : vendor.country,
          street: values.street,
          vendor_contact: JSON.stringify(vendorContactItem),
          image: values.image,
          social_media: {
            instagram: values.instagram,
            facebook: values.facebook,
            tiktok: values.tiktok,
            youtube: values.youtube,
            twitter: values.twitter,
          },
        };
        dispatch(onUpdateVendor(editDataSubmit));
      } else {
        let addDataSubmit = {
          clientId: values.client.value,
          companyId: values.company.value,
          name: values.name,
          email: values.email,
          password: values.password,
          phone: values.phone,
          fax: values.fax,
          tax_number: values.tax_number,
          website: values.website,
          idBank: values.idBank,
          bankId: values.bank.value,
          number: values.number,
          bank_name: values.bank_name,
          userId: values.user.value,
          description: values.description,
          zip: values.zip,
          village: typeof values.address.value === "object" && values.address.value.terms ? values.address.value.terms[0].value : "",
          district: typeof values.address.value === "object" && values.address.value.terms ? values.address.value.terms[values.address.value.terms.length - 4].value : "",
          city: typeof values.address.value === "object" && values.address.value.terms ? values.address.value.terms[values.address.value.terms.length - 3].value : "",
          province: typeof values.address.value === "object" && values.address.value.terms ? values.address.value.terms[values.address.value.terms.length - 2].value : "",
          country: typeof values.address.value === "object" && values.address.value.terms ? values.address.value.terms[values.address.value.terms.length - 1].value : "",
          street: values.street,
          vendor_contact: JSON.stringify(vendorContactItem),
          image: values.image,
          social_media: {
            instagram: values.instagram,
            facebook: values.facebook,
            tiktok: values.tiktok,
            youtube: values.youtube,
            twitter: values.twitter,
          },
        };
        dispatch(onAddNewVendor(addDataSubmit));
      }
      validation.resetForm();
      toggle();
    },
  });

  function handleVendorContactAdd() {
    let fc = [];
    if (vendorContactItem && vendorContactItem.length) {
      vendorContactItem.forEach((element) => {
        fc.push(element);
      });
    }

    fc.push({
      name: "",
      email: "",
      phone: "",
    });
    setVendorContactItem(fc);
  }

  // Delete Multiple
  const deleteMultiple = () => {
    const ele = document.querySelectorAll(".dataCheckbox:checked");
    const checkall = document.getElementById("checkBoxAll");
    ele.forEach((element) => {
      dispatch(onDeleteVendor(element.value));
    });
    checkall.checked = false;
  };

  document.title = "Supplier | Enterprise Resources Planning";

  return (
    <div className="page-content">
      <ExportCSVModal show={isExportCSV} onCloseClick={() => setIsExportCSV(false)} data={vendorList} />
      <DeleteModal show={deleteModal} onDeleteClick={handleDeleteVendor} onCloseClick={() => setDeleteModal(false)} />
      <ApproveModal data={vendor && vendor.name ? vendor.name : ""} show={approveModal} onApproveClick={handleApproveVendor} onCloseClick={() => setApproveModal(false)} />
      <DeleteModal
        show={deleteModalMulti}
        onDeleteClick={() => {
          deleteMultiple();
          setDeleteModalMulti(false);
        }}
        onCloseClick={() => setDeleteModalMulti(false)}
      />
      <Container fluid>
        <BreadCrumb title="Pengadaan Barang" pageTitle="Suplier">
          <div className="flex-shrink-0">
            <button
              type="button"
              className={userType === "admin" || userType === "client" || userType === "company" ? "btn btn-primary add-btn me-2" : userRole && userRole.split(",").indexOf("createVendor") !== -1 ? "btn btn-primary add-btn me-2" : "btn btn-primary add-btn me-2 d-none"}
              id="create-btn"
              onClick={() => {
                setIsEdit(false);
                toggle();
              }}
            >
              <i className="ri-group-line me-1 align-bottom fs-14"></i>Tambah
            </button>
            <ExportDoc data={printDoc} />
            {/* <button className={userType === "admin" || userType === "client" || userType === "company" ? "btn btn-soft-danger" : userRole && userRole.split(",").indexOf("deleteVendor") !== -1 ? "btn btn-soft-danger" : "btn btn-soft-danger d-none"} onClick={() => setDeleteModalMulti(true)}>
              <i className="ri-delete-bin-5-line me-1 align-bottom fs-15"></i>Delete
            </button> */}
          </div>
        </BreadCrumb>
        <Row>
          <Col xxl={8}>
            <Card>
              <CardHeader className="card-header border-0">
                <div className="d-flex align-items-center">
                  <h5 className="card-title mb-0 flex-grow-1">
                    {loading && (
                      <>
                        <Spinner color="primary" type="grow" size={"sm"}>
                          Loading...
                        </Spinner>
                        &nbsp;
                        <Spinner color="success" type="grow" size={"sm"}>
                          Loading...
                        </Spinner>
                        &nbsp;
                      </>
                    )}
                  </h5>
                </div>
              </CardHeader>
              <CardBody className="pt-0">
                <div>
                  <Nav className="nav-tabs nav-tabs-custom nav-success" role="tablist">
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "1" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("1", "all");
                        }}
                        href="#"
                      >
                        <i className=" ri-group-line me-1 align-bottom fs-14"></i>SEMUA SUPLIER
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "2" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("2", "DRAFT");
                        }}
                        href="#"
                      >
                        <i className="ri-information-line me-1 align-bottom fs-14"></i>DRAFT
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "3" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("3", "ACTIVE");
                        }}
                        href="#"
                      >
                        <i className="ri-checkbox-circle-line me-1 align-bottom fs-14"></i>ACTIVE
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "4" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("4", "INACTIVE");
                        }}
                        href="#"
                      >
                        <i className="ri-indeterminate-circle-line me-1 align-bottom fs-14"></i>INACTIVE
                      </NavLink>
                    </NavItem>
                  </Nav>
                  <Row className="mb-3">
                    <CardBody className="border border-top-0 border-end-0 border-start-0">
                      <form>
                        <Row>
                          <Col sm={1} className="col-xxl-1">
                            <div className="me-2 mb-3 col-12">
                              <select className="form-select" value={pageSize} onChange={onChangeInSelect}>
                                {[10, 25, 50, 100, 150, 250, 500, 1000, 2500, 5000].map((pageSize) => (
                                  <option key={pageSize} value={pageSize}>
                                    {pageSize}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </Col>
                          <Col sm={5}>
                            <div className="search-box me-2 mb-3 d-inline-block col-12">
                              <input
                                onChange={(e) => {
                                  setSearchValue(e.target.value);
                                  onChange(e.target.value);
                                  gotoPage(0);
                                }}
                                id="search-bar-0"
                                type="text"
                                className="form-control search"
                                placeholder={`${count} Cari...`}
                                value={searchValue ?? ""}
                              />
                              <i className="bx bx-search-alt search-icon"></i>
                            </div>
                          </Col>
                          <Col sm={6} className="col-xxl-3">
                            <div className="search-box me-2 mb-3 col-12">
                              <Flatpickr
                                className="form-control"
                                id="datepicker-publish-input"
                                placeholder="Pilih Tanggal"
                                value={filterDate}
                                options={{
                                  mode: "range",
                                  dateFormat: "Y/m/d",
                                }}
                                onChange={(selectedDates, dateStr) => {
                                  setFilterDate(dateStr);
                                }}
                              />
                              <i className="bx bx-calendar-alt search-icon"></i>
                            </div>
                          </Col>
                          <Col sm={4} className="col-xxl-2">
                            <div className="me-2 mb-3 col-12">
                              <Select
                                value={statusActive}
                                placeholder="Status"
                                onChange={(e) => {
                                  setStatusActive(e);
                                }}
                                options={statusActiveData}
                                name="choices-single-default"
                              ></Select>
                            </div>
                          </Col>
                          <Col sm={1}>
                            <div className="hstack gap-2">
                              <button
                                type="button"
                                className="btn btn-icon btn-md btn-soft-success waves-effect waves-light material-shadow-none w-100"
                                onClick={() => {
                                  handleFilter();
                                }}
                              >
                                <i className="ri-search-line align-bottom fs-16"></i>
                              </button>
                              <button
                                type="button"
                                className="btn btn-icon btn-md btn-soft-info waves-effect waves-light material-shadow-none w-100"
                                onClick={() => {
                                  handleResetFilter();
                                }}
                              >
                                <i className="mdi mdi-restore align-bottom fs-18"></i>
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </form>
                    </CardBody>
                  </Row>
                  <div className="table-responsive table-card mb-1">
                    <Table hover {...getTableProps()} className="align-middle table-nowrap">
                      <thead className="table-light">
                        {headerGroups.map((headerGroup, index) => (
                          <tr {...headerGroup.getHeaderGroupProps()} className={""} key={index}>
                            {headerGroup.headers.map((column, index) => (
                              <th {...column.getSortByToggleProps()} className={"" + generateFilterable(column)} key={index}>
                                {column.render("Header")}
                                {generateSortingIndicator(column)}
                                {/* <Filter column={column} /> */}
                              </th>
                            ))}
                          </tr>
                        ))}
                      </thead>
                      <tbody {...getTableBodyProps()}>
                        {page.map((row) => {
                          prepareRow(row);
                          return (
                            <Fragment key={row.getRowProps().key}>
                              <tr>
                                {row.cells.map((cell, index) => {
                                  return (
                                    <td {...cell.getCellProps()} key={index}>
                                      {cell.render("Cell")}
                                    </td>
                                  );
                                })}
                              </tr>
                            </Fragment>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>

                  <Row className="justify-content-md-end justify-content-center align-items-center p-2">
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button className="btn btn-light" onClick={previousPage} disabled={!canPreviousPage}>
                          {"<"}
                        </Button>
                      </div>
                    </Col>
                    <Col className="col-md-auto d-none d-md-block">
                      Halaman {pageIndex + 1} dari {pageOptions.length}
                    </Col>
                    <Col className="col-md-auto">
                      <Input type="number" min={1} style={{ width: 70 }} max={pageOptions.length} defaultValue={pageIndex + 1} onChange={onChangeInInput} />
                    </Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button className="btn btn-light" onClick={nextPage} disabled={!canNextPage}>
                          {">"}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </div>
                <Modal id="showModal" isOpen={modal} centered size="lg">
                  <ModalHeader className="bg-light p-3" toggle={toggle}>
                    {!!isEdit ? "Edit Supplier" : "Tambah Supplier"}
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                      return false;
                    }}
                  >
                    <ModalBody>
                      <div className="row">
                        <div className="col-lg-6">
                          <div className="mb-3">
                            <Label htmlFor="client-field" className="form-label">
                              Grup Usaha&nbsp;
                              {clientLoading ? (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              ) : (
                                ""
                              )}
                            </Label>
                            <Select
                              name="client"
                              value={validation.values.client}
                              isDisabled={userType === "admin" || userType === "client" ? false : true}
                              placeholder="Pilih Grup Usaha"
                              onChange={(e) => {
                                setCompanyList([]);
                                validation.setFieldValue("company", "");
                                validation.setFieldValue("client", e);
                                handleGetCompany(e.value);
                              }}
                              options={clientList}
                            ></Select>
                          </div>

                          <div className="mb-3">
                            <Label htmlFor="company-field" className="form-label">
                              Perusahaan&nbsp;
                              {companyLoading ? (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              ) : (
                                ""
                              )}
                            </Label>
                            <Select
                              name="company"
                              value={validation.values.company}
                              placeholder="Pilih Perusahaan"
                              isDisabled={userType === "admin" || userType === "client" ? false : true}
                              onChange={(e) => {
                                validation.setFieldValue("company", e);
                                handleUser(e.value);
                              }}
                              options={companyList}
                            ></Select>
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="vendorname-field" className="form-label">
                              Nama Supplier
                            </Label>
                            <Input name="name" id="vendorname-field" className="form-control" placeholder="Isi Nama Supplier" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.name ?? ""} invalid={validation.touched.name && validation.errors.name ? true : false} />
                            {validation.touched.name && validation.errors.name ? <FormFeedback type="invalid">{validation.errors.name}</FormFeedback> : null}
                          </div>
                          <div className="mb-3 d-none">
                            <Label htmlFor="password-field" className="form-label">
                              Password
                            </Label>
                            <Input name="password" id="password-field" className="form-control" placeholder="Enter Password" type="password" validate={{ required: { value: true } }} onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.password ?? ""} invalid={validation.touched.password && validation.errors.password ? true : false} />
                            {validation.touched.password && validation.errors.password ? (
                              <small className="text-danger" type="invalid">
                                {validation.errors.password}
                              </small>
                            ) : null}
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="phone-field" className="form-label">
                              Phone
                            </Label>
                            <Input name="phone" id="phone-field" className="form-control" placeholder="Isi No. Telepon" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.phone ?? ""} invalid={validation.touched.phone && validation.errors.phone ? true : false} />
                            {validation.touched.phone && validation.errors.phone ? <FormFeedback type="invalid">{validation.errors.phone}</FormFeedback> : null}
                          </div>
                          <div className="mb-3 d-none">
                            <Label htmlFor="des-field" className="form-label">
                              Alamat
                            </Label>
                            <Input name="address" id="des-field" className="form-control" placeholder="Isi Keterangan" type="textarea" rows={3} onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.address ?? ""} />
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="street-field" className="form-label">
                              Alamat
                            </Label>
                            <Input name="street" id="street-field" className="form-control" placeholder="Isi Alamat Supplier" type="textarea" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.street} invalid={validation.touched.street && validation.errors.street ? true : false} />
                            {validation.touched.street && validation.errors.street ? <FormFeedback type="invalid">{validation.errors.street}</FormFeedback> : null}
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="zip-field" className="form-label">
                              {props.t("Kode Pos")}
                            </Label>
                            <Input name="zip" id="zip-field" className="form-control" placeholder="Isi Kode Pos" type="number" validate={{ required: { value: true } }} onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.zip ?? ""} invalid={validation.touched.zip && validation.errors.zip ? true : false} />
                            {validation.touched.zip && validation.errors.zip ? <FormFeedback type="invalid">{validation.errors.zip}</FormFeedback> : null}
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="website-field" className="form-label">
                              Website
                            </Label>
                            <Input name="website" id="website-field" className="form-control" placeholder="Isi Website" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.website ?? ""} invalid={validation.touched.website && validation.errors.website ? true : false} />
                            {validation.touched.website && validation.errors.website ? <FormFeedback type="invalid">{validation.errors.website}</FormFeedback> : null}
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="email-field" className="form-label">
                              Email
                            </Label>
                            <Input name="email" id="email-field" className="form-control" placeholder="Isi email" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.email ?? ""} invalid={validation.touched.email && validation.errors.email ? true : false} />
                            {validation.touched.email && validation.errors.email ? <FormFeedback type="invalid">{validation.errors.email}</FormFeedback> : null}
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className=" mb-3">
                            <Label htmlFor="bank-field" className="form-label">
                              Bank
                            </Label>
                            <Select
                              name="bank"
                              value={validation.values.bank}
                              placeholder="Pilih Bank"
                              onChange={(e) => {
                                validation.setFieldValue("bank", e);
                              }}
                              options={bankList}
                            ></Select>
                            {validation.touched.bank && validation.errors.bank ? (
                              <small className="text-danger" type="invalid">
                                {validation.errors.bank}
                              </small>
                            ) : null}
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="number-field" className="form-label">
                              No. Rekening Bank
                            </Label>
                            <Input name="number" id="number-field" className="form-control" placeholder="Isi No. Rekening" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.number ?? ""} invalid={validation.touched.number && validation.errors.number ? true : false} />
                            {validation.touched.number && validation.errors.number ? <FormFeedback type="invalid">{validation.errors.number}</FormFeedback> : null}
                          </div>

                          <div className="mb-3">
                            <Label htmlFor="bank_name-field" className="form-label">
                              Nama Akun Rekening Bank
                            </Label>
                            <Input name="bank_name" id="bank_name-field" className="form-control" placeholder="Isi Nama Pemilik Akun Rekening" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.bank_name ?? ""} invalid={validation.touched.bank_name && validation.errors.bank_name ? true : false} />
                            {validation.touched.bank_name && validation.errors.bank_name ? <FormFeedback type="invalid">{validation.errors.bank_name}</FormFeedback> : null}
                          </div>

                          <div className="mb-3">
                            <Label htmlFor="tax_number-field" className="form-label">
                              No. Pajak
                            </Label>
                            <Input name="tax_number" id="tax_number-field" className="form-control" placeholder="Isi No. Pajak" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.tax_number ?? ""} invalid={validation.touched.tax_number && validation.errors.tax_number ? true : false} />
                            {validation.touched.tax_number && validation.errors.tax_number ? <FormFeedback type="invalid">{validation.errors.tax_number}</FormFeedback> : null}
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="description-field" className="form-label">
                              Keterangan (optional)
                            </Label>
                            <Input name="description" id="description-field" className="form-control" placeholder="Isi Keterangan" type="textarea" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.description} invalid={validation.touched.description && validation.errors.description ? true : false} />
                            {validation.touched.description && validation.errors.description ? <FormFeedback type="invalid">{validation.errors.description}</FormFeedback> : null}
                          </div>
                          <div className="mb-3 position-relative">
                            <Label htmlFor="vendor_contact" className="form-label">
                              Kontak Supplier
                            </Label>
                            <button
                              type="button"
                              className="btn btn-sm btn-label btn-soft-success position-absolute top-50 end-0 translate-middle-y"
                              onClick={() => {
                                handleVendorContactAdd();
                              }}
                            >
                              <i className="ri-add-line label-icon align-middle fs-16 me-1"></i> Tambah
                            </button>
                          </div>
                          {vendorContactItem.map((o, i) => {
                            return (
                              <div key={i} className="border-bottom mb-3 d-flex gap-3 align-items-center">
                                <div>
                                  <div className="row">
                                    <div className="mb-3">
                                      <Label htmlFor="number-field" className="form-label">
                                        Nama
                                      </Label>
                                      <Input
                                        name={`vendorContactItem.${i}.name`}
                                        className="form-control"
                                        placeholder="Nama Kontak"
                                        type="text"
                                        value={vendorContactItem[i].name ?? ""}
                                        onChange={(e) => {
                                          validation.setFieldValue(`vendorContactItem.${i}.name`, e.target.value);
                                          vendorContactItem[i].name = e.target.value;
                                        }}
                                        onBlur={validation.handleBlur}
                                      />
                                    </div>
                                  </div>
                                  <div className="row">
                                    <div className="mb-3">
                                      <Label htmlFor="number-field" className="form-label">
                                        Telepon
                                      </Label>
                                      <Input
                                        name={`vendorContactItem.${i}.phone`}
                                        className="form-control"
                                        placeholder="Telepon Kontak"
                                        type="text"
                                        value={vendorContactItem[i].phone ?? ""}
                                        onChange={(e) => {
                                          validation.setFieldValue(`vendorContactItem.${i}.phone`, e.target.value);
                                          vendorContactItem[i].phone = e.target.value;
                                        }}
                                        onBlur={validation.handleBlur}
                                      />
                                    </div>
                                    <div className="mb-3">
                                      <Label htmlFor="number-field" className="form-label">
                                        Email
                                      </Label>
                                      <Input
                                        name={`vendorContactItem.${i}.email`}
                                        className="form-control"
                                        placeholder="Email Kontak"
                                        type="text"
                                        value={vendorContactItem[i].email ?? ""}
                                        onChange={(e) => {
                                          validation.setFieldValue(`vendorContactItem.${i}.email`, e.target.value);
                                          vendorContactItem[i].email = e.target.value;
                                        }}
                                        onBlur={validation.handleBlur}
                                      />
                                    </div>
                                    <div className="mb-3">
                                      <Label htmlFor="number-field" className="form-label">
                                        Posisi
                                      </Label>
                                      <Input
                                        name={`vendorContactItem.${i}.position`}
                                        className="form-control"
                                        placeholder="Posisi Kontak"
                                        type="text"
                                        value={vendorContactItem[i].position ?? ""}
                                        onChange={(e) => {
                                          validation.setFieldValue(`vendorContactItem.${i}.position`, e.target.value);
                                          vendorContactItem[i].position = e.target.value;
                                        }}
                                        onBlur={validation.handleBlur}
                                      />
                                    </div>
                                  </div>
                                </div>
                                <Button
                                  className="btn-icon btn btn-sm btn-soft-danger remove-item-btn"
                                  style={{
                                    width: "70px",
                                  }}
                                  onClick={() => {
                                    setVendorContactItem((val) => [...val.slice(0, i), ...val.slice(i + 1)]);
                                    // let data = cellProps.row.original;
                                    // onClickDelete(data);
                                  }}
                                >
                                  <i className="ri-delete-bin-line fs-15 text-danger"></i>
                                </Button>
                              </div>
                            );
                          })}
                          <div className="mb-3 position-relative">
                            <Label htmlFor="vendor_contact" className="form-label">
                              Gambar
                            </Label>
                            <button
                              type="button"
                              className="btn btn-sm btn-label btn-soft-success position-absolute top-50 end-0 translate-middle-y"
                              onClick={() => {
                                setMediaType("image");
                                toggleMedia();
                              }}
                            >
                              <i className="ri-file-cloud-fill label-icon align-middle fs-16 me-1"></i> Media
                            </button>
                          </div>
                          {validation.values.image !== "" ? (
                            <div className="border-bottom mb-3">
                              <div className="d-flex justify-content-between align-items-center mb-3">
                                <div className="me-2">
                                  <img src={validation.values.image === "" ? logo : `${api.MEDIA_URL}/media/${validation.values.image}`} alt="" data-dz-thumbnail="" height="30" className="avatar-sm rounded bg-light" />
                                </div>

                                <div className="text-truncate">{validation.values.image}</div>
                                <div>
                                  <Link
                                    to="#"
                                    className={"btn-icon btn btn-sm btn-soft-danger remove-item-btn mx-2"}
                                    onClick={(e) => {
                                      // e.stopPropagation();
                                      validation.setFieldValue("image", "");
                                    }}
                                  >
                                    <i className="ri-delete-bin-line fs-15 text-danger"></i>
                                  </Link>
                                </div>
                              </div>
                            </div>
                          ) : null}
                        </div>
                        <div className="col-lg-4 d-none">
                          <Row>
                            <Col lg={6}>
                              <div className="mb-3">
                                <Label htmlFor="instagram-field" className="form-label">
                                  Instagram
                                </Label>
                                <Input name="instagram" id="instagram-field" className="form-control" placeholder="Isi instagram" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.instagram ?? ""} invalid={validation.touched.instagram && validation.errors.instagram ? true : false} />
                                {validation.touched.instagram && validation.errors.instagram ? <FormFeedback type="invalid">{validation.errors.instagram}</FormFeedback> : null}
                              </div>
                            </Col>
                            <Col lg={6}>
                              <div className="mb-3">
                                <Label htmlFor="facebook-field" className="form-label">
                                  Facebook
                                </Label>
                                <Input name="facebook" id="facebook-field" className="form-control" placeholder="Isi facebook" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.facebook ?? ""} invalid={validation.touched.facebook && validation.errors.facebook ? true : false} />
                                {validation.touched.facebook && validation.errors.facebook ? <FormFeedback type="invalid">{validation.errors.facebook}</FormFeedback> : null}
                              </div>
                            </Col>
                          </Row>
                          <Row>
                            <Col lg={6}>
                              <div className="mb-3">
                                <Label htmlFor="instagram-field" className="form-label">
                                  Tiktok
                                </Label>
                                <Input name="tiktok" id="tiktok-field" className="form-control" placeholder="Isi tiktok" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.tiktok ?? ""} invalid={validation.touched.tiktok && validation.errors.tiktok ? true : false} />
                                {validation.touched.tiktok && validation.errors.tiktok ? <FormFeedback type="invalid">{validation.errors.tiktok}</FormFeedback> : null}
                              </div>
                            </Col>
                            <Col lg={6}>
                              <div className="mb-3">
                                <Label htmlFor="facebook-field" className="form-label">
                                  Youtube
                                </Label>
                                <Input name="youtube" id="youtube-field" className="form-control" placeholder="Isi youtube" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.youtube ?? ""} invalid={validation.touched.youtube && validation.errors.youtube ? true : false} />
                                {validation.touched.youtube && validation.errors.youtube ? <FormFeedback type="invalid">{validation.errors.youtube}</FormFeedback> : null}
                              </div>
                            </Col>
                          </Row>
                          <Row>
                            <Col lg={6}>
                              <div className="mb-3">
                                <Label htmlFor="instagram-field" className="form-label">
                                  Twiter
                                </Label>
                                <Input name="twitter" id="twitter-field" className="form-control" placeholder="Isi twitter" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.twitter ?? ""} invalid={validation.touched.twitter && validation.errors.twitter ? true : false} />
                                {validation.touched.twitter && validation.errors.twitter ? <FormFeedback type="invalid">{validation.errors.twitter}</FormFeedback> : null}
                              </div>
                            </Col>
                          </Row>
                        </div>
                      </div>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button
                          type="button"
                          className="btn btn-light"
                          onClick={() => {
                            setModal(false);
                          }}
                        >
                          Tutup
                        </button>
                        <button type="submit" className="btn btn-success" disabled={loading}>
                          <span className="d-flex align-items-center">
                            <span className="flex-grow-1 me-2">{!!isEdit ? "EDIT SUPLIER" : "TAMBAH SUPLIER"}</span>
                            {loading && (
                              <Spinner size="sm" className="flex-shrink-0" role="status">
                                Loading...
                              </Spinner>
                            )}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>
                <ModalInputFile onSelect={handleSelectFile} loading={loading} modal={modalMedia} toggle={toggleMedia} />
              </CardBody>
            </Card>
          </Col>
          <Col xxl={4}>
            <Card>
              <div className="card-body">
                <div className="table-responsive table-card">
                  <Accordion id="default-accordion-example" flush open={open} toggle={toggleAccordion}>
                    <AccordionItem>
                      <AccordionHeader targetId="1" className="accordion-header" id="headingOne">
                        GENERAL INFORMATION
                      </AccordionHeader>
                      <AccordionBody accordionId="1">
                        <div className="row">
                          <div className="col-lg-12">
                            <table className="table border table-responsive table-striped fs-13 mb-3">
                              <tbody>
                                <tr>
                                  <td className="p2 p2 fw-medium text-primary text-uppercase" colSpan={"2"}>
                                    Kontak Supplier
                                  </td>
                                </tr>
                                {info.vendor_contact ? (
                                  info.vendor_contact.map((row) => {
                                    return (
                                      <Fragment key={row.id}>
                                        <tr>
                                          <td className="p2">Name</td>
                                          <td className="p2"> {row.name ? row.name : "-"} </td>
                                        </tr>
                                        <tr>
                                          <td className="p2">Email</td>
                                          <td className="p2"> {row.email ? row.email : "-"} </td>
                                        </tr>
                                        <tr>
                                          <td className="p2">Phone</td>
                                          <td className="p2"> {row.phone ? row.phone : "-"} </td>
                                        </tr>
                                      </Fragment>
                                    );
                                  })
                                ) : (
                                  <tr></tr>
                                )}
                              </tbody>
                            </table>
                            <table className="table border table-responsive table-striped fs-13 mb-3">
                              <tbody>
                                <tr>
                                  <td className="p2 p2 fw-medium text-primary text-uppercase" colSpan={"2"}>
                                    INFORMASI ALAMAT
                                  </td>
                                </tr>
                                {info.vendor_address &&
                                  info.vendor_address.map((row) => {
                                    return (
                                      <Fragment key={row.id}>
                                        <tr>
                                          <td className="p2">Address</td>
                                          <td className="p2">
                                            {row.village ? row.village : "-"}, {row.city ? row.city : "-"}, {row.district ? row.district : "-"}, {row.province ? row.province : "-"}
                                          </td>
                                        </tr>
                                        <tr>
                                          <td className="p2">Street</td>
                                          <td className="p2">
                                            {row.description ? row.description : "-"} - {row.code ? row.code : "-"}
                                          </td>
                                        </tr>
                                        <tr>
                                          <td className="p2" colSpan={"2"}></td>
                                        </tr>
                                      </Fragment>
                                    );
                                  })}
                              </tbody>
                            </table>
                            <table className="table border table-responsive table-striped fs-13 mb-3">
                              <tbody>
                                <tr>
                                  <td className="p2 p2 fw-medium text-primary text-uppercase" colSpan={"2"}>
                                    INFORMASI BANK
                                  </td>
                                </tr>
                                {info.vendor_bank &&
                                  info.vendor_bank.map((row) => {
                                    return (
                                      <Fragment key={row.id}>
                                        <tr>
                                          <td className="p2" colSpan="2">
                                            {row.bank_data_bank ? row.bank_data_bank.name : "-"}
                                          </td>
                                        </tr>
                                        <tr>
                                          <td className="p2">Primary</td>
                                          <td className="p2">{row.isPrimary ? "Yes" : "No"}</td>
                                        </tr>
                                        <tr>
                                          <td className="p2">No. Rekening Bank</td>
                                          <td className="p2">{row.number ? row.number : "-"}</td>
                                        </tr>
                                      </Fragment>
                                    );
                                  })}
                              </tbody>
                            </table>
                            <table className="table border table-responsive table-striped fs-13 mb-3">
                              <tbody>
                                <tr>
                                  <td className="p2">NO. PAJAK</td>
                                  <td className="p2">{info.tax_number ? info.tax_number : "-"}</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </AccordionBody>
                    </AccordionItem>
                    <AccordionItem>
                      <AccordionHeader targetId="2" className="accordion-header" id="headingTwo">
                        OTHER CONTACT INFORMATION
                      </AccordionHeader>
                      <AccordionBody accordionId="2">
                        <div className="col-lg-12">
                          {(info.vendor_contact || []).map((row) => {
                            return (
                              <table className="table border table-responsive table-striped fs-13 mb-3" key={row.id}>
                                <tbody>
                                  <tr>
                                    <td className="p2">Name</td>
                                    <td className="p2">{row.name ? row.name : "-"} </td>
                                  </tr>
                                  <tr>
                                    <td className="p2">Position</td>
                                    <td className="p2">{row.position ? row.position : "-"} </td>
                                  </tr>
                                  <tr>
                                    <td className="p2">Email</td>
                                    <td className="p2">{row.email ? row.email : "-"} </td>
                                  </tr>
                                  <tr>
                                    <td className="p2">Phone</td>
                                    <td className="p2">{row.phone ? row.phone : "-"} </td>
                                  </tr>
                                </tbody>
                              </table>
                            );
                          })}
                        </div>
                      </AccordionBody>
                    </AccordionItem>
                    <AccordionItem>
                      <AccordionHeader targetId="3" className="accordion-header" id="headingThree">
                        OTHER INFORMATION
                      </AccordionHeader>
                      <AccordionBody accordionId="3">
                        <table className="table table-responsive table-striped fs-12">
                          <tbody>
                            <tr>
                              <td className="p2">Dibuat Oleh</td>
                              <td className="p2">{info.vendor_createdby && info.vendor_createdby.name ? info.vendor_createdby.name + " - " + handleValidDate(info.createdat) : "-"}</td>
                            </tr>
                            <tr>
                              <td className="p2">Diedit Oleh</td>
                              <td className="p2">{info.vendor_updatedby && info.vendor_updatedby.name ? info.vendor_updatedby.name + " - " + handleValidDate(info.updatedat) : "-"}</td>
                            </tr>
                            <tr>
                              <td className="p2">Approved By</td>
                              <td className="p2">{info.vendor_approvedby && info.vendor_approvedby.name ? info.vendor_approvedby.name + " - " + handleValidDate(info.approvedat) : "-"}</td>
                            </tr>
                          </tbody>
                        </table>
                      </AccordionBody>
                    </AccordionItem>
                  </Accordion>
                </div>
              </div>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

Vendor.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

export default withRouter(withTranslation()(Vendor));
